import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { getDocumentProcessInfo, getSignedDocument } from '../../services/trustedxService';
// (Estos son métodos que replican la lógica de "trustedxService" en Angular)

import { storeFile } from '../../utils/indexedDB';
// o como manejes el guardado en IndexedDB

export const SignCallbackPage = () => {
    const [searchParams] = useSearchParams();
    const processId = searchParams.get('signer_process_id');
    const status = searchParams.get('status');
    const token = searchParams.get('token');

    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!processId || !status || !token) {
            setError('Faltan parámetros');
            navigate('/signer/signDocument', { state: { alertType: 'error', alertMessageKey: 'componentAlerts.error' } });
            return;
        }

        if (status === 'canceled') {
            setError('La firma fue cancelada');
            navigate('/signer/signDocument', { state: { alertType: '', alertMessageKey: '' } });
            return;
        }

        // 1) Llamar a getDocumentProcessInfo
        getDocumentProcessInfo(processId, token)
            .then(resp => {                                   // si resp.result.status === 'finished', llamamos a getSignedDocument
                    if (resp?.result?.status === 'finished') {
                        getSignedDocument(processId, status, token)
                            .then(docResp => {
                                if (docResp.filename) {
                                    storeFile(docResp.filename, docResp.filecontent)
                                        .then(() => {
                                            setLoading(false);
                                            navigate('/signer/sharedDocument', {
                                                state: { alertType: 'success', alertMessageKey: 'componentAlerts.success' }
                                            });
                                        })
                                        .catch(() => {
                                            setError('No se pudo almacenar el PDF');
                                            navigate('/signer/signDocument', { state: { alertType: 'error', alertMessageKey: 'componentAlerts.error' } });
                                        });
                                } else {
                                    setError('Ocurrió un error al descargar el PDF');
                                    navigate('/signer/signDocument', { state: { alertType: 'error', alertMessageKey: 'componentAlerts.error' } });
                                }
                            })
                            .catch(() => {
                                setError('Ocurrió un error al descargar el PDF');
                                navigate('/signer/signDocument', { state: { alertType: 'error', alertMessageKey: 'componentAlerts.error' } });
                            });
                    } else if (resp?.result?.status === 'failed') {
                        setError('El proceso de firma falló');
                        navigate('/signer/signDocument', { state: { alertType: 'error', alertMessageKey: 'componentAlerts.error' } });
                    } else {
                        setError(`Estado inesperado: ${resp?.result?.status}`);
                        navigate('/signer/signDocument', { state: { alertType: 'error', alertMessageKey: 'componentAlerts.nocerts' } });
                    }

            })
            .catch(() => {
                setError('Fallo al obtener la información del proceso');
                navigate('/signer/signDocument', { state: { alertType: 'error', alertMessageKey: 'componentAlerts.error' } });
            });

    }, [processId, status, token, navigate]);

    if (loading) {
        return <div>Cargando ...</div>;
    }

    if (error) {
        return (
            <div>
                <p>Error: {error}</p>
                <button onClick={() => navigate('/signer/signDocument')}>Regresar</button>
            </div>
        );
    }

    return null; // En teoría nunca llega aquí si rediriges al final
};
